import { api, TAGS } from "@/store/api"
import {
  IDevAdjustBody,
  IDevAdjustResponse,
  IWalletResponse
} from "@/store/apis/walletAPI/wallet.types"

export const walletAPI = api
  .enhanceEndpoints({ addTagTypes: [TAGS.WALLET] })
  .injectEndpoints({
    endpoints: (build) => ({
      getWallet: build.query<IWalletResponse, void>({
        query: () => ({ url: "/wallet/me", method: "GET" }),
        providesTags: [TAGS.WALLET]
      }),
      devAdjustWallet: build.mutation<IDevAdjustResponse, IDevAdjustBody>({
        query: (data) => ({ url: "/wallet/dev/adjust", method: "POST", data }),
        invalidatesTags: [TAGS.WALLET]
      })
    })
  })

export const { useGetWalletQuery, useDevAdjustWalletMutation } = walletAPI
